import { createSlice } from "@reduxjs/toolkit";
import { data } from "jquery";

const initialState = {
  data: [],
  dataTable: [],
  kitchenCard: [],
  kitchenSocket: null,
  orderSocket: null,
  notification: [],
  notificationSocket: null,
  notificationCount: null,
};

const kitchenSlice = createSlice({
  name: "kitchen",
  initialState,
  reducers: {
    setDataTable: (state, action) => {
      state.dataTable = action.payload;
    },
    setKitchenCard: (state, action) => {
      state.kitchenCard = action.payload;
    },
    setKitchenSocket: (state, action) => {
      state.kitchenSocket = action.payload;
    },
    setOrderSocket: (state, action) => {
      state.orderSocket = action.payload;
    },
    setNotification: (state, action) => {
      state.notification = action.payload;
    },
    setNotificationCount: (state, action) => {
      state.notificationCount = action.payload;
    },
    setNotificationSocket: (state, action) => {
      state.notificationSocket = action.payload;
    },
    clearDataTable: (state) => {
      state.dataTable = [];
    },
    clearKitchenCard: (state) => {
      state.kitchenCard = [];
    },
    clearKitchenSocket: (state) => {
      state.kitchenSocket = null;
    },
    clearOrderSocket: (state) => {
      state.orderSocket = null;
    },
    clearNotification: (state) => {
      state.notification = [];
    },
    clearNotificationCount: (state) => {
      state.notificationCount = null;
    },
    clearNotificationSocket: (state) => {
      state.notificationSocket = null;
    },
    removeOrderItems: (state, action) => {
      const { id, indexes } = action.payload;
      const objectIndex = state.kitchenCard.findIndex((item) => item.id === id);

      if (objectIndex !== -1) {
        if (indexes.length === state.kitchenCard[objectIndex].orderItems.length) {
          state.kitchenCard = state.kitchenCard.filter((item) => item.id !== id);
        } else {
          state.kitchenCard[objectIndex].orderItems = state.kitchenCard[objectIndex].orderItems.filter((_, index) => !indexes.includes(index));
        }
      }
    },
    removeCard: (state, action) => {
      const id = action.payload;
      state.kitchenCard = state.kitchenCard.filter((item) => item.id !== id);
    },
    updateOrderItems: (state, action) => {
      const { targetIndex, info, id } = action.payload;
      const card = state.kitchenCard.find((item) => item?.id === id);
      card.orderItems[targetIndex] = { ...info };
      // console.log(JSON.stringify(card));
      // console.log(action.payload);
    },
  },
});
export const {
  setDataTable,
  clearDataTable,
  setKitchenCard,
  clearKitchenCard,
  removeOrderItems,
  removeCard,
  updateOrderItems,
  setKitchenSocket,
  clearKitchenSocket,
  setOrderSocket,
  clearOrderSocket,
  setNotificationCount,
  setNotification,
  clearNotificationCount,
  clearNotification,
  setNotificationSocket,
  clearNotificationSocket,
} = kitchenSlice.actions;

export default kitchenSlice.reducer;
